/**
 * List Schema of TypeSms
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {TypeSms} from '@/model/resource/TypeSms'

/* TODO: review generated schema */
export class ListTypeSmsSchema extends Schema {
  readonly name = 'ListTypeSms'

  readonly fieldSet: FieldSet<TypeSms> = {
    idTypePk: (): FieldComponent => ({
      is: Component.Render,
    }),
    ativo: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.bool(schema.model.ativo),
      },
    }),
    nome: (): FieldComponent => ({
      is: Component.Render,
    }),
  }
}
